import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ScholarshipModal = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
      const modal = new window.bootstrap.Modal(
        document.getElementById("scholarshipModal")
      );
      modal.show();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShow(false);
    const modal = window.bootstrap.Modal.getInstance(
      document.getElementById("scholarshipModal")
    );
    if (modal) {
      modal.hide();
    }
  };

  const handleApplyNow = (e) => {
    e.preventDefault();
    handleClose();
    setTimeout(() => {
      navigate("/apply-now");
    }, 300); // Give modal time to close
  };

  return (
    <>
      <div
        className="modal fade"
        id="scholarshipModal"
        tabIndex="-1"
        aria-labelledby="scholarshipModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content border-0 p-0 position-relative" style={{ borderRadius: "12px", overflow: "hidden" }}>
            {/* Close Button */}
            <button
              type="button"
              className="btn-close position-absolute top-0 end-0 m-3 z-3"
              aria-label="Close"
              onClick={handleClose}
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                padding: "8px",
                borderRadius: "50%",
                boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
              }}
            ></button>

            {/* Banner Image Link */}
            <div className="modal-body p-0">
              <a href="/apply-now" onClick={handleApplyNow}>
                <img
                  src="/images/Hunarmand Punjab popup banner.jpg"
                  alt="Scholarship Batch Open - Apply Now"
                  className="w-100 img-fluid"
                  style={{ cursor: "pointer", display: "block" }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScholarshipModal;
